const normalizeQuantity = (value) => {
  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) return 0;
  return Math.max(0, parsedValue);
};

const normalizeTrackedFlag = (value) => {
  if (value === undefined || value === null || value === "") return false;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "1" || normalized === "true") return true;
    if (normalized === "0" || normalized === "false" || normalized === "") {
      return false;
    }
  }

  return false;
};

export const getProductQuantity = (product = {}) =>
  normalizeQuantity(product.qty  ?? 0);

export const isProductTracked = (product = {}) =>
  normalizeTrackedFlag(product.isTracked);

export const getStockPolicy = (product = {}) => {
  const quantity = getProductQuantity(product);
  const isTracked = isProductTracked(product);
  const isOutOfStock = isTracked && quantity === 0;
  const isLowStock = isTracked && quantity > 0 && quantity < 5;
  const canAddToCartByStock = !isTracked || quantity > 0;

  return {
    quantity,
    isTracked,
    isOutOfStock,
    isLowStock,
    canAddToCartByStock,
  };
};

export const getCappedCartQuantity = (requestedQuantity, product = {}) => {
  const safeRequestedQuantity = normalizeQuantity(requestedQuantity);
  const { isTracked, quantity } = getStockPolicy(product);
  if (!isTracked) {
    return safeRequestedQuantity;
  }
  return Math.min(safeRequestedQuantity, quantity);
};
